import { render, staticRenderFns } from "./LogisticsUsageRecord.vue?vue&type=template&id=b588884c&scoped=true"
import script from "./LogisticsUsageRecord.vue?vue&type=script&lang=js"
export * from "./LogisticsUsageRecord.vue?vue&type=script&lang=js"
import style0 from "./LogisticsUsageRecord.vue?vue&type=style&index=0&id=b588884c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b588884c",
  null
  
)

export default component.exports